export default __webpack_public_path__ + "static/media/earlybenefit.f443af80.svg";